import { BasePage } from '@/components/ui/base-page'

export function StartupConsultingPage() {
  return (
    <BasePage
      title="undefined"
      description="undefined"
    >
      {/* Add StartupConsultingPage specific content here */}
    </BasePage>
  )
}